import { useFetchCreditsBalance } from "../hooks/useFetchCreditsBalance";
import { ContactLink } from "./ContactLink";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../shadcn/Tooltip";
import { Info } from "lucide-react";
import { isNullOrUndefined } from "src/utils/objects";

export const CREDITS_RESET_HINT = "Note this resets to 3,000 on the 1st of every month";

export const CreditsBalance = () => {
  const { data, isLoading } = useFetchCreditsBalance();
  const availableCredits = data?.balance;
  const formattedCredits = data?.formattedBalance;

  // // Show error message when credits are zero
  if (
    !isLoading &&
    !isNullOrUndefined(availableCredits) &&
    availableCredits <= 0
  ) {
    return (
      <span className="text-sm text-center text-gray-500">
        No credits remaining.&nbsp;
        <ContactLink>Purchase more.</ContactLink>
      </span>
    );
  }

  return (
    <div className="flex flex-row items-center text-sm text-gray-500">
      Available credits:&nbsp;
      {isLoading ? (
        <div className="relative min-w-[40px] top-[1px] inline-block w-8 h-4 bg-gray-200 animate-pulse rounded" />
      ) : (
        <div className="flex flex-row items-center gap-1 min-w-[40px]">
          <strong>{formattedCredits}</strong>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="w-3 h-3 cursor-pointer text-gray-400 hover:text-gray-600" />
              </TooltipTrigger>
              <TooltipContent className="flex flex-col text-center gap-1">
                <p>
                  <ContactLink>Purchase more credits</ContactLink>
                </p>
                <p>{CREDITS_RESET_HINT}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}
    </div>
  );
};
